const trapFocusHandlers = {};
let previouslyFocused = null;
let lastInteractionType = "mouse";
if (typeof window !== "undefined") {
  window.addEventListener("keydown", () => {
    lastInteractionType = "keyboard";
  }, { capture: true, passive: true });
  window.addEventListener("mousedown", () => {
    lastInteractionType = "mouse";
  }, { capture: true, passive: true });
  window.addEventListener("touchstart", () => {
    lastInteractionType = "mouse";
  }, { capture: true, passive: true });
}
function isKeyboardUser() {
  return lastInteractionType === "keyboard";
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
function trapFocus(container, elementToFocus) {
  removeTrapFocus();
  previouslyFocused = /** @type {HTMLElement | null} */
  document.activeElement;
  const focusable = getFocusableElements(container);
  if (!focusable.length) {
    return;
  }
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  trapFocusHandlers.keydown = (event) => {
    if (event.key !== "Tab") return;
    const activeEl = document.activeElement;
    if (!event.shiftKey && activeEl === last) {
      event.preventDefault();
      first == null ? void 0 : first.focus();
    } else if (event.shiftKey && (activeEl === first || activeEl === container)) {
      event.preventDefault();
      last == null ? void 0 : last.focus();
    }
  };
  trapFocusHandlers.focusin = (event) => {
    if (event.target instanceof Node && !container.contains(event.target)) {
      event.stopPropagation();
      first == null ? void 0 : first.focus();
    }
  };
  document.addEventListener("keydown", trapFocusHandlers.keydown, true);
  document.addEventListener("focusin", trapFocusHandlers.focusin, true);
  if (isKeyboardUser()) {
    container.focus();
  }
}
function removeTrapFocus() {
  trapFocusHandlers.keydown && document.removeEventListener("keydown", trapFocusHandlers.keydown, true);
  trapFocusHandlers.focusin && document.removeEventListener("focusin", trapFocusHandlers.focusin, true);
  if (previouslyFocused && previouslyFocused.focus) {
    previouslyFocused.focus({ preventScroll: true });
  }
  previouslyFocused = null;
}
export {
  isKeyboardUser as i,
  removeTrapFocus as r,
  trapFocus as t
};
